import apiService from './api';

class WebhookEndpointsService {
  async getEndpoints() {
    try {
      const response = await apiService.get('/v1/webhooks/endpoints');
      return response;
    } catch (error) {
      console.error('Erro ao buscar endpoints:', error);
      throw error;
    }
  }

  async getEndpoint(id) {
    try {
      const response = await apiService.get(`/v1/webhooks/endpoints/${id}`);
      return response;
    } catch (error) {
      console.error('Erro ao buscar endpoint:', error);
      throw error;
    }
  }

  async createEndpoint(data) {
    try {
      const response = await apiService.post('/v1/webhooks/endpoints', data);
      return response;
    } catch (error) {
      console.error('Erro ao criar endpoint:', error);
      throw error;
    }
  }

  async updateEndpoint(id, data) {
    try {
      const response = await apiService.patch(`/v1/webhooks/endpoints/${id}`, data);
      return response;
    } catch (error) {
      console.error('Erro ao atualizar endpoint:', error);
      throw error;
    }
  }

  async deleteEndpoint(id) {
    try {
      const response = await apiService.delete(`/v1/webhooks/endpoints/${id}`);
      return response;
    } catch (error) {
      console.error('Erro ao deletar endpoint:', error);
      throw error;
    }
  }

  async regenerateToken(id) {
    try {
      const response = await apiService.post(`/v1/webhooks/endpoints/${id}/regenerate-token`);
      return response.data;
    } catch (error) {
      console.error('Erro ao regenerar token:', error);
      throw error;
    }
  }

  async getEndpointLogs(id) {
    try {
      const response = await apiService.get(`/v1/webhooks/endpoints/${id}/logs`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar logs:', error);
      throw error;
    }
  }
}

export default new WebhookEndpointsService();